import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Title } from './Title';

// export const Bolden: React.FC<React.PropsWithChildren> = ({ children }) => {
// if (!children) {
//   return <p>Bold target was not supplied</p>;
// }
// if (!React.isValidElement(children)) {
//   return <p>Bold target was not supplied</p>;
// }
// const bold = { fontWeight: '900' };
// const modifiedChildren = React.Children.map(children, (child) => {
//   if (!React.isValidElement(child)) {
//     return child;
//   }
//   const modifiedProps = {
//     ...child.props,
//     sx: child.props.sx ? { ...child.props.sx, ...bold } : bold,
//   };
//   return React.cloneElement(child as JSX.Element, modifiedProps);
// });
// };

// use something more simple for now, as this is not heavily used, and causing type issues
export const Bold1: React.FC<{
  text: string;
}> = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontWeight: "900"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <Title.Medium text={text} sx={t1} />;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};